export const enum ToolbarStates {
  SYMBOL = 'symbol',
  EL_ANIMATION = '',
  EL_STYLE = 'elStyle',
  SECTION = 'section',
  EL_POSITION = 'elPosition',
  SLIDE_DESIGN = 'slideDesign',
  SLIDE_ANIMATION = 'slideAnimation',
  MULTI_POSITION = 'multiPosition',
  EL_DATA_OPTIONS = 'elDataOptions',
  WIDGET_POSITION = 'widgetPosition',
  DRAG_DROP_SUB_LAYOUT = 'dragDropSubLayout',
}
